export class BookDetailReservationGroupModel {
  id: number;
  menu_item_id: number;
  book_detail_id: number;
  title: string;
  description: string;
  default_time: Date;

  constructor(id = 0,
              menu_item_id = 0,
              book_detail_id = 0,
              title = '',
              description = '',
              default_time = new Date()) {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.book_detail_id = book_detail_id;
    this.title = title;
    this.description = description;
    this.default_time = default_time;
  }
}
